import { FARE_ATTRIBUTES_FILTER_CHANGED } from '../../../../../actions/detailsPanel';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { FilterState } from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/filtersBookingPanel';

export type {
  BookingPanelFilterEnabledAction,
  BookingPanelBadgeAction,
  BaggageInfoModalCloseAction,
} from '@web-platform/shared-universal-types/src/redux/actions/bookingPanelOfDayView/filters';

export const INITIAL_STATE: FilterState = {
  selected: [],
};

export const filters = (state: FilterState = INITIAL_STATE, action: Action): FilterState => {
  switch (action.type) {
    case FARE_ATTRIBUTES_FILTER_CHANGED: {
      return {
        selected: action.payload.filterState,
      };
    }

    default:
      return state;
  }
};

export const getSelected = (state: FilterState) => state.selected;
